import { Icon, LinkButton } from '@eluve/components';

/** Back affordance at the top of a settings drill-in page. */
export const SettingsBackLink = ({
  to = '..',
  label = 'Back',
}: {
  to?: string;
  label?: string;
}) => (
  <LinkButton to={to} variant="ghost" size="xs" className="self-start">
    <Icon name="ChevronLeft" size="auto" />
    {label}
  </LinkButton>
);
